import { render } from "./DevicePermissionBanner.vue.js?vue&type=template&id=1cf52b16!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DevicePermissionBanner.vue?vue&type=template&id=1cf52b16"
import script from "./DevicePermissionBanner.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DevicePermissionBanner.vue?vue&type=script&lang=js"
export * from "./DevicePermissionBanner.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DevicePermissionBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/DevicePermissionBanner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cf52b16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cf52b16', __exports__)) {
    api.reload('1cf52b16', __exports__)
  }
  
  module.hot.accept("./DevicePermissionBanner.vue.js?vue&type=template&id=1cf52b16!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DevicePermissionBanner.vue?vue&type=template&id=1cf52b16", () => {
    api.rerender('1cf52b16', render)
  })

}


export default __exports__